/*********************************************************************
 * The Initial Developer of the content of this file is NETCONOMY.
 * All portions of the code written by NETCONOMY are property of
 * NETCONOMY. All Rights Reserved.
 *
 * NETCONOMY Software & Consulting GmbH
 * Hilmgasse 4, A-8010 Graz (Austria)
 * FN 204360 f, Landesgericht fuer ZRS Graz
 * Tel: +43 (316) 815 544
 * Fax: +43 (316) 815544-99
 * www.netconomy.net
 *
 * (c) 2022 by NETCONOMY Software & Consulting GmbH
 *********************************************************************/
import gigya from '../gigya/rbata.gigya';

const navigationState = {
    $checkoutNav: undefined,
    stepState:    1,

    init() {
        this.$checkoutNav = $('.checkout-nav');
        this.getCurrentStep();
    },

    getCurrentStep() {
        const currentStep = this.$checkoutNav.find('.checkout-nav__step--current');

        if (window.isGigyaUserAuthenticated) {
            this.stepState = 2;
        }

        if (currentStep.length) {
            this.stepState = currentStep.data('step');

            // In case user is logged in, sign in step is automatically done - will be skipped anyway
            if (window.isGigyaUserAuthenticated && this.stepState < 2) {
                this.stepState = 2;
            }

            if (this.stepState > this.getStepState()) {
                this.setStepState(this.stepState);
            }
        }

        this.applyState();
    },

    getStepState() {
        return sessionStorage.getItem('checkoutNavStepState');
    },

    setStepState(val) {
        sessionStorage.setItem('checkoutNavStepState', val);
    },

    resetStepState() {
        sessionStorage.setItem('checkoutNavStepState', '1');
    },

    applyState() {
        const navSteps = this.$checkoutNav.find('.checkout-nav__step');
        $.each(navSteps, (i, stepElem) => {
            const step = $(stepElem);
            if (step.data('step') <= this.getStepState()) {
                step.addClass('checkout-nav__step--active');
            }
        });
        this.$checkoutNav.css({opacity: 1});
    }
}

export default navigationState;